// src/pages/lgbtqia/Resources.js
import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

export default function Resources() {
  return (
    <Box className="p-6">
      <Typography variant="h5" sx={{ mb: 2 }}>Resources & Helplines</Typography>
      <List>
        <ListItem>
          <ListItemText primary="National AIDS Control helpline" secondary="1097 (India)" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Mental health helpline (Kiran)" secondary="1800-599-0019" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Local NGOs / community orgs" secondary="Add your district resources here." />
        </ListItem>
      </List>
    </Box>
  );
}
